import { FC, useState } from 'react'
import { useForm } from 'react-hook-form'

import StartWidget from './parts/start-widget/start-widget'
import EmailWidget from './parts/email-widget/email-widget'
import FinalWidget from './parts/final-widget/final-widget'
import RegFlow from './parts/reg-flow/reg-flow'
import NOPhoneReg from './parts/nophone-widget/nophone-widget'
import NoAttemptsWidget from './parts/noattempts-widget/noattempts-widget'
import ErrorWidget from './parts/error-widget/error-widget'
import DopInpurWidget from './parts/dop-input-widget/dop-input-widget'

import { FieldsNameVoc } from 'constants/auth/profile-data'
import { ABType } from 'constants/data'
import { FormValues, RegStep, FieldCode, FieldId, isAdAgree, isUserAgree } from './data'
import Auth from 'store/auth'

interface IRegistrationCode {
  handleClose: () => void
}

const RegistrationCode: FC<IRegistrationCode> = ({ handleClose }) => {
  const [currStep, setStep] = useState<RegStep>(RegStep.START)
  const { ABVersion } = Auth.useAuth()
  const isAVersion = ABVersion === ABType.A

  const {
    control,
    formState: { errors },
    getValues,
    setValue,
    setError,
    handleSubmit,
    clearErrors,
  } = useForm<FormValues>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    defaultValues: {
      [FieldsNameVoc.countryCode]: 'RU',
      [FieldsNameVoc.email]: '',
      [FieldsNameVoc.Specialities]: [],
      [isAdAgree]: isAVersion ? true : false,
      [isUserAgree]: false,
      [FieldCode]: '',
      [FieldId]: 0,
    },
  })
  const generateStep = () => {
    switch (currStep) {
      case RegStep.PHONE_FLOW_OK: {
        return (
          <FinalWidget
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            setError={setError}
            setStep={setStep}
            theme="phone"
          />
        )
      }
      case RegStep.PHONE_FLOW_NOREG: {
        return <NOPhoneReg getValues={getValues} setStep={setStep} />
      }
      case RegStep.EMAIL_FLOW_OK: {
        return (
          <FinalWidget
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            setError={setError}
            setStep={setStep}
            theme="email"
          />
        )
      }
      case RegStep.NEW_REG_FLOW: {
        return (
          <RegFlow
            control={control}
            errors={errors}
            clearErrors={clearErrors}
            getValues={getValues}
            setValue={setValue}
            setError={setError}
            setStep={setStep}
            handleSubmit={handleSubmit}
          />
        )
      }
      case RegStep.EMAIL_WIDGET: {
        return (
          <EmailWidget
            control={control}
            errors={errors}
            clearErrors={clearErrors}
            getValues={getValues}
            setValue={setValue}
            setStep={setStep}
            handleSubmit={handleSubmit}
          />
        )
      }
      case RegStep.DOP_INPUTS: {
        return (
          <DopInpurWidget
            control={control}
            errors={errors}
            clearErrors={clearErrors}
            getValues={getValues}
            handleSubmit={handleSubmit}
            handleClose={handleClose}
          />
        )
      }
      case RegStep.NO_ATTEMPTS_PHONE: {
        return <NoAttemptsWidget />
      }

      case RegStep.NO_ATTEMPTS_EMAIL: {
        return <NoAttemptsWidget />
      }

      case RegStep.ERROR: {
        return <ErrorWidget />
      }

      default: {
        return (
          <StartWidget
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            setStep={setStep}
            clearErrors={clearErrors}
            handleSubmit={handleSubmit}
          />
        )
      }
    }
  }
  return generateStep()
}

export default RegistrationCode
